<template>
  <div>
    <slot />
  </div>
</template>

<script>
import { getArticles } from '../api/article';
import { getEvent } from '../api/event';
import { formatTimestampToDate } from '../utils/dateUtil'; 
import { eventBus } from '@/utils/eventBus.js';

export default {
  name: 'RequestProvider',
  data() {
    return {
      dataWrapper: {
        articles: [],
        eventData: null // 新增：事件数据存储
      },
      fetchStatus: {
        isFetched: false
      },
      eventFetchStatus: {
        isLoading: false,
        isFetched: false
      },
      error: null,
      channel: '', 
      // 新增：事件相关状态
      currentEventId: null,
      routeWatcher: null
    };
  },
  methods: {
    async fetchArticles() {
      if (!this.fetchStatus.isFetched) {
        try {
          const filter = {
            'tag': '通知公告'
          };
          
          const response = await getArticles({
            'filter':filter
          });
          if (response && response.list) {
            // 定义 channel 枚举
            // 处理返回数据
            const processedArticles = response.list.map(article => {
              return {
                ...article,
                // 根据枚举转换 channel 字段
                orgchannel:article.channel,
                // 将 createdat 时间戳转成年月日
                createdat: formatTimestampToDate(article.createdat),
              };
            });

            this.dataWrapper.articles = processedArticles;
          } else {
            throw new Error('响应数据格式不正确');
          }
        } catch (err) {
          this.error = err;
          console.error('获取文章数据失败:', err);
        } finally {
          this.fetchStatus.isFetched = true;
        }
      }
    },
    async fetchEvent(id) {
      if (!this.eventFetchStatus.isFetched) {
        this.eventFetchStatus.isLoading = true;
        try {
          const response = await getEvent(id);
          this.dataWrapper.eventData = response.data;
          this.eventFetchStatus.isFetched = true;
          this.error = null;
        } catch (error) {
          this.error = error;
          this.dataWrapper.eventData = null;
          console.error('获取事件数据失败:', error);
        } finally {
          this.eventFetchStatus.isLoading = false;
        }
      }
    },
    checkRouteAndFetchEvent() {
      const match = this.$route.path.match(/^\/events\/([0-9a-fA-F-]+)\/.*/);
      if (match) {
        const eventId = match[1];
        if (eventId !== this.currentEventId) {
          this.currentEventId = eventId;
          this.eventFetchStatus.isFetched = false;
          this.fetchEvent(eventId);
        }
      } else {
        this.currentEventId = null;
        this.dataWrapper.eventData = null;
        this.eventFetchStatus.isFetched = false;
      }
    }
  },
  created() {
    this.fetchArticles();
    eventBus.$on('channel-updated', (newChannel) => {
      this.channel = newChannel;
      this.fetchArticles();
    });
    // 新增：初始化事件路由监听
    this.checkRouteAndFetchEvent();
    this.routeWatcher = this.$watch(
      () => this.$route.path,
      () => this.checkRouteAndFetchEvent()
    );
  },
  beforeDestroy() {
    eventBus.$off('channel-updated');
    // 新增：移除路由监听
    if (this.routeWatcher) {
      this.routeWatcher();
    }
  },
  provide() {
    return {
      dataWrapper: this.$data.dataWrapper,
      fetchStatus: this.$data.fetchStatus,
      fetchArticles: this.fetchArticles,
      eventFetchStatus: this.$data.eventFetchStatus,
      fetchEvent: this.fetchEvent,
      error: this.$data.error
    };
  }
};
</script>